
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/safer-dating/post/[countryCode]/[smartBanner]/[ampValue]/[slug]",
      function () {
        return require("private-next-pages/[lang]/safer-dating/post/[countryCode]/[smartBanner]/[ampValue]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/safer-dating/post/[countryCode]/[smartBanner]/[ampValue]/[slug]"])
      });
    }
  